export default __webpack_public_path__ + "static/media/ahappypancake.321d53af.jpeg";